import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import {
  CurrentFileType,
  FileStatusType,
  GovernmentalEntityStateType,
  GovernmentalEntityVersion,
} from "./types/governmentalEntity";

const initialState: GovernmentalEntityStateType = {
  versions: [],
  loading: false,
  error: null,
  currentFile: null,
  fileStatus: {
    loading: false,
    error: false,
    message: "",
    justUploaded: false,
  },
};

const governmentalEntitySlice = createSlice({
  name: "governmentalEntity",
  initialState,
  reducers: {
    getVersions: (_state, _action: PayloadAction<{ limit?: number } | undefined>) => {},
    uploadVersion: (_state, _action: PayloadAction<{ file: File }>) => {},
    getVersionsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getVersionsSuccess: (
      state,
      action: PayloadAction<GovernmentalEntityVersion[]>
    ) => {
      state.loading = false;
      state.versions = action.payload;
      state.error = null;
    },
    getVersionsError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setVersions: (
      state,
      action: PayloadAction<GovernmentalEntityVersion[]>
    ) => {
      state.versions = action.payload;
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    uploadVersionRequest: (state) => {
      state.fileStatus = {
        loading: true,
        error: false,
        message: "",
        justUploaded: false,
      };
    },
    uploadVersionSuccess: (
      state,
      _action: PayloadAction<GovernmentalEntityVersion | null>
    ) => {
      state.fileStatus = {
        loading: false,
        error: false,
        message: "",
        justUploaded: true,
      };
      state.currentFile = null;
    },
    uploadVersionError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.fileStatus = {
        loading: false,
        error: !!action.payload,
        message: action.payload,
        justUploaded: false,
      };
    },
    setCurrentFile: (
      state,
      action: PayloadAction<CurrentFileType | null>
    ) => {
      state.currentFile = action.payload;
    },
    setFileStatus: (
      state,
      action: PayloadAction<Partial<FileStatusType>>
    ) => {
      state.fileStatus = {
        loading: action.payload.loading ?? state.fileStatus.loading,
        error: action.payload.error ?? state.fileStatus.error,
        message: action.payload.message ?? state.fileStatus.message,
        justUploaded: action.payload.justUploaded ?? state.fileStatus.justUploaded,
      };
    },
    clearFileStatus: (state) => {
      state.fileStatus = {
        loading: false,
        error: false,
        message: "",
        justUploaded: false,
      };
    },
  },
});

export default governmentalEntitySlice.reducer;

export const actions = governmentalEntitySlice.actions;

export const governmentalEntitySelector = (state: RootState) =>
  state.governmentalEntity;
